function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getVerifyRecords, countVerifyRecords, confirmVerify, newRequestId } from '@/api/alliance';
var PENDING = 'PENDING_CONFIRM';
export default {
  name: 'AllianceVerifyDesk',
  data: function data() {
    return {
      loading: false,
      list: [],
      total: 0,
      autoRefresh: true,
      // 与后端 verify.confirm.timeout.seconds 默认值一致，仅用于文案
      timeoutHint: '5 分钟',
      now: Date.now(),
      confirmVisible: false,
      submitting: false,
      current: null,
      items: [],
      query: {
        keyword: '',
        status: PENDING,
        page: 1,
        size: 20
      }
    };
  },
  watch: {
    autoRefresh: function autoRefresh(val) {
      val ? this.startAutoRefresh() : this.stopAutoRefresh();
    }
  },
  created: function created() {
    var _this = this;
    this.loadList();
    this.startAutoRefresh();
    // 剩余时间要走秒，单独一个 ticker 驱动，不跟着刷新列表一起打接口
    this.ticker = setInterval(function () {
      _this.now = Date.now();
    }, 1000);
  },
  beforeDestroy: function beforeDestroy() {
    this.stopAutoRefresh();
    if (this.ticker) clearInterval(this.ticker);
  },
  computed: {
    itemsTotal: function itemsTotal() {
      return this.items.reduce(function (total, item) {
        return total + (item.unitPrice || 0) * (item.quantity || 0);
      }, 0).toFixed(2);
    }
  },
  methods: {
    startAutoRefresh: function startAutoRefresh() {
      var _this2 = this;
      this.stopAutoRefresh();
      this.refreshTimer = setInterval(function () {
        return _this2.loadList();
      }, 30000);
    },
    stopAutoRefresh: function stopAutoRefresh() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
    },
    yuan: function yuan(fen) {
      return "\xA5".concat(((fen || 0) / 100).toFixed(2));
    },
    remainSeconds: function remainSeconds(row) {
      if (!row.expireTime) return 0;
      return Math.max(0, Math.ceil((new Date(row.expireTime).getTime() - this.now) / 1000));
    },
    loadList: function () {
      var _loadList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$Promise$all, _yield$Promise$all2, list, total, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              _context.n = 2;
              return Promise.all([getVerifyRecords(_objectSpread({}, this.query)), countVerifyRecords(PENDING).catch(function () {
                return 0;
              })]);
            case 2:
              _yield$Promise$all = _context.v;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              list = _yield$Promise$all2[0];
              total = _yield$Promise$all2[1];
              this.list = Array.isArray(list) ? list : [];
              this.total = Number(total) || 0;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
            case 4:
              _context.p = 4;
              this.loading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function loadList() {
        return _loadList.apply(this, arguments);
      }
      return loadList;
    }(),
    onSearch: function onSearch() {
      this.query.page = 1;
      this.loadList();
    },
    onReset: function onReset() {
      this.query = {
        keyword: '',
        status: PENDING,
        page: 1,
        size: 20
      };
      this.loadList();
    },
    onPageChange: function onPageChange(page) {
      this.query.page = page;
      this.loadList();
    },
    onSizeChange: function onSizeChange(size) {
      this.query.size = size;
      this.query.page = 1;
      this.loadList();
    },
    onConfirm: function onConfirm(row) {
      this.current = row;
      // 已经填过明细的（用户端带上来的）先回显，金额从分换算成元
      this.items = (row.items || []).map(function (item) {
        return {
          productName: item.productName,
          sku: item.sku,
          unitPrice: (item.unitPrice || 0) / 100,
          quantity: item.quantity || 1
        };
      });
      if (!this.items.length) this.addItem();
      this.confirmVisible = true;
    },
    addItem: function addItem() {
      this.items.push({
        productName: '',
        sku: '',
        unitPrice: 0,
        quantity: 1
      });
    },
    submitConfirm: function () {
      var _submitConfirm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var filled, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              filled = this.items.filter(function (item) {
                return item.productName;
              });
              if (!this.items.some(function (item) {
                return !item.productName && (item.unitPrice || item.quantity > 1);
              })) {
                _context2.n = 1;
                break;
              }
              this.$message.warning('填了金额或数量的行必须写商品名称');
              return _context2.a(2);
            case 1:
              this.submitting = true;
              _context2.p = 2;
              _context2.n = 3;
              return confirmVerify({
                requestId: newRequestId(),
                verifyNo: this.current.verifyNo,
                // 金额一律按分传，避免浮点数在两端各自四舍五入
                items: filled.map(function (item) {
                  return {
                    productName: item.productName,
                    sku: item.sku || '',
                    unitPrice: Math.round((item.unitPrice || 0) * 100),
                    quantity: item.quantity || 1,
                    amount: Math.round((item.unitPrice || 0) * 100) * (item.quantity || 1)
                  };
                })
              });
            case 3:
              this.$message.success('核销成功');
              this.confirmVisible = false;
              this.loadList();
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
            case 5:
              _context2.p = 5;
              this.submitting = false;
              return _context2.f(5);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 4, 5, 6]]);
      }));
      function submitConfirm() {
        return _submitConfirm.apply(this, arguments);
      }
      return submitConfirm;
    }(),
    /** 列表里的商品摘要：首个商品名 + 还有几件 */goodsSummary: function goodsSummary(items) {
      var first = items[0] || {};
      return items.length > 1 ? "".concat(first.productName, " \u7B49").concat(items.length, "\u4EF6") : first.productName;
    }
  }
};